import type { FC } from 'react'
import styled from '@emotion/styled'

import ApplePodcastsBadge from './assets/ApplePodcastsBadge.svg'
import GooglePodcastsBadge from './assets/GooglePodcastsBadge.svg'
import SpotifyBadge from './assets/SpotifyBadge.svg'

interface EpisodePlayersProps {
  simplecastId?: string
  applePodcastsUrl?: string
  googlePodcastsUrl?: string
  spotifyUrl?: string
}
const EpisodePlayers: FC<EpisodePlayersProps> = ({ simplecastId, applePodcastsUrl, googlePodcastsUrl, spotifyUrl }) => {
  return (
    <Wrapper>
      {simplecastId && (
        <iframe
          width="100%"
          height="203"
          frameBorder="no"
          scrolling="no"
          seamless={true}
          src={simplecastId}
          title="Play the featured episode"
        ></iframe>
      )}
      <BadgesWrapper>
        {applePodcastsUrl && (
          <Badge href={applePodcastsUrl} target="_blank" title="Listen on Apple Podcasts">
            <ApplePodcastsBadge />
          </Badge>
        )}
        {googlePodcastsUrl && (
          <Badge href={googlePodcastsUrl} target="_blank" title="Listen on Google Podcasts">
            <GooglePodcastsBadge />
          </Badge>
        )}
        {spotifyUrl && (
          <Badge href={spotifyUrl} target="_blank" title="Listen on Spotify">
            <SpotifyBadge />
          </Badge>
        )}
      </BadgesWrapper>
    </Wrapper>
  )
}

export default EpisodePlayers

const Wrapper = styled.div`
  display: grid;
  gap: 24px;

  ${({ theme }) => theme.breakpoints.up(`md`)} {
    gap: 40px;
  }
`

const BadgesWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(143px, 159px));
  column-gap: 9px;
  row-gap: 5px;

  ${({ theme }) => theme.breakpoints.up(`md`)} {
    gap: 17px;
    row-gap: 14px;
  }
`

const Badge = styled.a``
